import Header from "../components/Header";
import Footer from "../containers/Footer";
import Slider3D from "../components/Slider";
import FAQ from "../pages/FAQ";

import resume1 from "../assets/images/sample_imgs/resume1.png";
import Resume2 from "../assets/images/sample_imgs/Resume2.png";
import resume3 from "../assets/images/sample_imgs/resume3.png";
import Resume4 from "../assets/images/sample_imgs/Resume4.png";
import Resume5 from "../assets/images/sample_imgs/Resume5.png";
import resume6 from "../assets/images/sample_imgs/resume6.png";
import resume7 from "../assets/images/sample_imgs/Resume7.png";
import resume8 from "../assets/images/sample_imgs/Resume8.png";
import bannerBG from "../assets/images/sample_imgs/bg.png";


import "../assets/css/style.css";
import "../assets/css/slider.css";

export default function Home() {
  return (
    <>
      <Header />

      {/* Banner */}
      <div className="banner"   style={{
    backgroundImage: `url(${bannerBG})`
  }}>
        <Slider3D
          images={[
            resume1,
            Resume2,
            resume3,
            Resume4,
            Resume5,
            resume6,
            resume7,
            resume8,
          ]}
        />

        <div className="content">
          <h1>Professional Resume Templates</h1>
          <div className="buttons">
            <button
              className="button1"
              onClick={() => alert("Coming Soon!")}
            >
              Create Resume
            </button>

            <button
              className="button2"
              onClick={() => alert("Coming Soon!")}
            >
              Import Old Resume
            </button>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="why-choose-us">
        <h2>Why Choose Us?</h2>
        <p>
          We provide a wide range of professional resume templates to help you
          stand out in the job market. Our templates are designed by experts
          and are easy to customize.
        </p>

        <div className="features">
          <div className="feature">
            <div className="wcu-icon">1</div>
            <h3>Easy to Use</h3>
            <p>Our templates are user-friendly and easy to customize.</p>
          </div>

          <div className="feature">
            <div className="wcu-icon">2</div>
            <h3>Professional Design</h3>
            <p>Designed by experts to make you stand out.</p>
          </div>

          <div className="feature">
            <div className="wcu-icon">3</div>
            <h3>Affordable</h3>
            <p>Get high-quality templates at an affordable price.</p>
          </div>
        </div>
      </div>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-heading">Why Choose Our Resume Builder</h2>
        <p className="section-description">
          Transform your job application with intuitive tools and professionally
          designed templates crafted for success.
        </p>

        <div className="features-container">
          <FeatureItem image={resume1} title="Resume Customization">
            Personalize your resume with smart suggestions tailored to your
            target role and industry.
          </FeatureItem>

          <FeatureItem image={Resume2} title="ATS Optimized">
            Ensure compatibility with Applicant Tracking Systems to boost your
            interview opportunities.
          </FeatureItem>

          <FeatureItem image={resume3} title="Resume Refresh">
            Easily update outdated resumes with modern layouts and content
            enhancements.
          </FeatureItem>

          <FeatureItem image={Resume4} title="Premium Templates">
            Select from sleek, industry-specific designs to make your resume
            stand out.
          </FeatureItem>

          <FeatureItem image={Resume5} title="Live Editing">
            Make instant changes with real-time previews and fast editing.
          </FeatureItem>

          <FeatureItem image={resume6} title="ATS Checker">
            Upload your resume to instantly check ATS compliance.
          </FeatureItem>
        </div>
      </section>

      {/* FAQ */}
      <FAQ />

      <Footer />
    </>
  );
}

// Feature Item Component
function FeatureItem({ image, title, children }) {
  return (
    <div className="feature-item">
      <img className="feature-icon" alt={title} src={image} />
      <h3 className="feature-title">{title}</h3>
      <p className="feature-text">{children}</p>
    </div>
  );
}
